"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./styles.css");
var ChevronIcon = function (_a) {
    var _b = _a.down, down = _b === void 0 ? false : _b;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-icon-container', 'centered', down && 'rotate-180') },
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "6", viewBox: "0 0 10 6" },
            react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
                react_1.default.createElement("path", { d: "M-7 15h24V-9H-7z" }),
                react_1.default.createElement("path", { fill: 'var(--navbar-icons)', d: "M5 0l4.756 4.6a.806.806 0 0 1 .002 1.156.856.856 0 0 1-1.192.003L5 2.317 1.434 5.759a.856.856 0 0 1-1.192-.003A.806.806 0 0 1 .244 4.6L5 0z" })))));
};
exports.default = ChevronIcon;
